<template>
    <x-page title="Group Update Report">
        <template #header-actions>
            <x-back-button :disabled="isLoading" 
                :display-warning="false"
                :clickHandler="router => router.replace('/admin/reports')" />
        </template>
        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter"
            :open="true">
            <x-panel title="Range Tanggal" style="margin-bottom:15px;">
                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <x-form-group id="start_date">
                            <x-input-group>
                                <template #prepend>
                                    Dari
                                </template>
                                <input id="start_date"
                                    type="date"
                                    class="form-control"
                                    v-model="filters.gathering_hasnt_updated_start_date" />
                            </x-input-group>
                        </x-form-group>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <x-form-group id="end_date">
                            <x-input-group>
                                <template #prepend>
                                    Sampai
                                </template>
                                <input id="end_date"
                                    type="date"
                                    class="form-control"
                                    v-model="filters.gathering_hasnt_updated_end_date" />
                            </x-input-group>
                        </x-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <x-form-group>
                            <span class="text-warning" style="display:block; margin-top:5px;">
                                <i class="fa fa-exclamation-triangle" /> Group yang <b>BELUM UPDATE</b> pada range tanggal diatas akan tampil di tabel
                            </span>
                        </x-form-group>
                    </div>
                </div>
            </x-panel>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Kategori">
                        <x-ajax-dropdown url="/api/group-categories"
                            label="label"
                            :allow-empty="true"
                            v-model="selectedCategory"
                            class="form-control"
                            placeholder="Ketik kategori group" />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="[
            '#',
            'Group',
            'Kategori',
            'Leader',
            'Update Absensi Terakhir',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    {{ resource.label }}
                </td>
                <td class="nowrap">
                    {{ resource | get('category.label', '-') }}
                </td>
                <td class="nowrap">
                    {{ resource | get('leader.name', '-') }}
                </td>
                <td class="nowrap">
                    <span v-if="resource.last_gathering_update">
                        {{ resource.last_gathering_update | date }}
                    </span> 
                    <span v-else>
                        Belum pernah di-update
                    </span>
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../../components/XAjaxDropdown.vue'
import XBackButton from '../../../components/XBackButton.vue'
import XFilterBox from '../../../components/XFilterBox.vue'
import XFormGroup from '../../../components/XFormGroup.vue'
import XInputGroup from '../../../components/XInputGroup.vue'
import XPage from '../../../components/XPage.vue'
import XPagination from '../../../components/XPagination.vue'
import XPanel from '../../../components/XPanel.vue'
import XTable from '../../../components/XTable.vue'
import { dateFormat } from '../../../constants'
import { handleGeneralXhrError } from '../../../helpers'
import FilterableMixin from '../../../mixins/FilterableMixin'
import PaginationMixin from '../../../mixins/PaginationMixin'

const defaultFilters = {
    category_id: null,
    gathering_hasnt_updated_end_date: moment().clone().endOf('week').format(dateFormat),
    gathering_hasnt_updated_start_date: moment().clone().startOf('week').format(dateFormat),
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XPage,
        XFilterBox,
        XPanel,
        XAjaxDropdown,
        XTable,
        XPagination,
        XFormGroup,
        XInputGroup,
        XBackButton,
        XPage,
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
            selectedCategory: null,
        }
    },
    methods: {
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/groups', {
                params: route.query
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    append: [
                        'last_gathering_update',
                        'leader',
                    ],
                    page: 1,
                    with: [
                        'category',
                    ],
                    without_global_scopes: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
    ],
    watch: {
        'filters.category_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'selectedCategory', `/api/group-categories/${id}`)
            },
            immediate: true,
        },
        selectedCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'category_id')
            },
            deep: true,
        },
    }
}
</script>